import { useEffect, useState } from 'react';
import { authRepository } from '@shared/domain/auth/auth.repository';
import { configuration } from 'configuration';

export const WithAuthentication = ({ children }: { children: JSX.Element }) => {
  const [component, setcomponent] = useState<JSX.Element | null>(null);
  useEffect(() => {
    authRepository.isAuthenticated().then((res) => {
      if (res) setcomponent(children);
      else {
        window.location.href = `${configuration.api.baseUrl}/account/signin?redirectUri=${window.location.href}`;
        setcomponent(null);
      }
    });
  });

  return component;
};
